<h2 mat-dialog-title>{{ 'Registrer nye versjoner' }}</h2>
<mat-dialog-content>
  <p>{{ 'Enkelte filer finnes fra før, for disse vil en ny versjon bli registrert'|translate }}</p>

  <h3>{{ 'Eksisterende filer'|translate }}</h3>
  <ul data-testid="eksisterende-filer">
    @for (fil of nyeVersjoner; track fil) {
      <li>{{ fil.name }}</li>
    }
  </ul>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-button [mat-dialog-close]="false">{{ "Avbryt" | translate }}</button>
  <button mat-raised-button [mat-dialog-close]="true">
    {{ 'Registrer {antall} nye versjoner'|translate: {antall: nyeVersjoner.length} }}
  </button>
</mat-dialog-actions>
